import React from "react";
import {AdjustmentsListPrices, AdjustmentsListProductSpecific} from "../../util/request.ts";
import {formatAmountWithCurrency, formatAmountWithCurrencyOverPeriod} from "../../util/formatter.ts";

export default function PriceListAdjustmentComponent(props: { adjustments: AdjustmentsListPrices }) {
    return (
        <>
            <h3>Øvrige priser</h3>
            <ul className="ellipse-explainer">
                <li>
                    <i className="ellipse ellipse-fiber"></i> <span>Bredbånd via fibernet</span>
                </li>
                <li>
                    <i className="ellipse ellipse-mbb"></i> <span>5G-internet</span>
                </li>
                <li>
                    <i className="ellipse ellipse-coax"></i> <span>Bredbånd via kabel-tv-stik</span>
                </li>
            </ul>

            <table cellSpacing="0" className="adjustments-table">
                <thead>
                <tr>
                    <th>Produkt</th>
                    <th>Pris</th>
                </tr>
                </thead>

                <tbody>

                <ProductPrices title={"Oprettelse (inkl. afsendelse af udstyr)"} adjustment={props.adjustments.initiation}/>

                <tr>
                    <td>
                        Forgæves teknikerbesøg <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">
                        <strong>Teknikerbesøg ved oprettelse:</strong><br/>
                        Hvis teknikeren går forgæves den dag, hvor du har din aftalte teknikertid, så vil du blive opkrævet {formatAmountWithCurrency(props.adjustments.vain_technician)} Det gælder også hvis teknikeren ikke har kunne udføre arbejdet, f.eks. at møbler står i vejen eller lign.
                        For at undgå at teknikeren går forgæves, så skal der være en myndig person på adressen når teknikeren kommer.
                        <br/><br/>
                        <strong>Teknikerbesøg ved fejlretning:</strong><br/>
                        Hvis du selv er ansvarlig for fejlen, så vil du blive pålagt et gebyr på {formatAmountWithCurrency(props.adjustments.vain_technician)} Udfører tekniker fejlretning på installationen og dette er betalbart, så vil du blive opkrævet for dette.
                    </span>
                    </div>
                    </td>
                    <td>{formatAmountWithCurrency(props.adjustments.vain_technician)}</td>
                </tr>

                <tr>
                    <td>
                        Teknikerbesøg <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">En standard fiberinstallation koster {formatAmountWithCurrency(props.adjustments.technician.fiber as number)}</span>
                    </div>
                    </td>
                    <td>
                        <i className="ellipse ellipse-fiber"><span>Bredbånd via fibernet</span></i> {formatAmountWithCurrency(props.adjustments.technician.fiber as number)}
                    </td>
                </tr>

                <ProductPrices
                    title={"Flyttegebyr"} tooltip={
                    <>
                        Hvis du flytter adresse og ønsker at tage din internetforbindelse med,
                        så bliver du opkrævet et gebyr afhængigt af, hvilken forbindelse du kan få på din nye adresse.
                    </>
                } adjustment={props.adjustments.moving}
                />

                <tr>
                    <td>
                        Afsendelse af udstyr <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">Ønsker du at få en ny router, så bliver du opkrævet {formatAmountWithCurrency(props.adjustments.shipping)} for forsendelsen af udstyret.</span>
                    </div>
                    </td>
                    <td>{formatAmountWithCurrency(props.adjustments.shipping)}</td>
                </tr>

                <tr>
                    <td>Genåbning af produkt efter rykkerlukning</td>
                    <td>{formatAmountWithCurrency(props.adjustments.soft_open)}</td>
                </tr>

                <ProductPrices title={"Bortkommet / ødelagt trådløs router (momsfrit)"} adjustment={props.adjustments.router}/>

                <tr>
                    <td>Bortkommet / ødelagt fiber mediekonverter (momsfrit)</td>
                    <td>{formatAmountWithCurrency(props.adjustments.fiber_gpon)}</td>
                </tr>

                <tr>
                    <td>Rykkergebyr faktura (momsfrit)</td>
                    <td>{formatAmountWithCurrency(props.adjustments.reminder_fee_invoice)}</td>
                </tr>

                <tr>
                    <td>Rykkergebyr for ikke-returneret udstyr (momsfrit)</td>
                    <td>{formatAmountWithCurrency(props.adjustments.reminder_fee_hardware)}</td>
                </tr>

                <tr>
                    <td>Regning betalt via Betalingskort</td>
                    <td>{formatAmountWithCurrency(props.adjustments.payment_card)}</td>
                </tr>

                <ProductPrices
                    title={"Skift til nyt produkt"} tooltip={
                    <>
                        Ønsker du at skifte din internetforbindelse til et nyt produkt, så vil du blive opkrævet et gebyr for selve oprettelsen.
                        Hvis du skal have tekniker ud i forbindelse med en opgradering, så skal du være opmærksom på, at du kan blive pålagt et gebyr for teknikeren.
                    </>
                } adjustment={props.adjustments.new_product}
                />

                <tr>
                    <td>Fast, offentlig IP-addresse</td>
                    <td>
                        <i className="ellipse ellipse-fiber"><span>Bredbånd via fibernet</span></i> {formatAmountWithCurrencyOverPeriod(props.adjustments.static_ip)}
                    </td>
                </tr>

                <tr>
                    <td>Dynamisk IP-addresse</td>
                    <td>{formatAmountWithCurrencyOverPeriod(props.adjustments.dyn_ip)}</td>
                </tr>

                <tr>
                    <td>
                        Ekstra gravemeter ved etablering af fiber pr. meter <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">
                        Hvis du ønsker at få fiberboksen placeret længere nede af husmuren, som afviger fra en standard fiberinstallation, så koster det 450 kr. pr. ekstra gravemeter.
                        Gælder kun på TDC fiber.
                    </span>
                    </div>
                    </td>
                    <td>{formatAmountWithCurrency(props.adjustments.extra_digging_meter)}</td>
                </tr>

                <tr>
                    <td>
                        Indvendig installation af fiberboks <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">
                                Ønsker du at få begge fiberbokse placeret indenfor, så du slipper for at den ydre fiberboks hænger på den ydre husfacade &ndash; så koster det {props.adjustments.fiberbox_inside} kr. ekstra, udover prisen på en standard fiberinstallation.
                                Gælder kun på TDC fiber.
                            </span>
                    </div>
                    </td>
                    <td>{formatAmountWithCurrency(props.adjustments.fiberbox_inside)}</td>
                </tr>

                <tr>
                    <td>
                        Indvendig kabeltræk <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">
                                Skal du have din fiberboks gemt væk i et teknikrum inde i dit hus?
                                Så kræver det at du får lavet et indvendig kabeltræk og det koster {formatAmountWithCurrency(props.adjustments.cable_inside)} ekstra, udover prisen på en standard fiberinstallation.
                                Gælder kun på TDC fiber.
                            </span>
                    </div>
                    </td>
                    <td>{formatAmountWithCurrency(props.adjustments.cable_inside)}</td>
                </tr>

                </tbody>
            </table>
        </>
    )
}

export function ProductPrices(props: { title: string, tooltip?: React.ReactNode, adjustment: AdjustmentsListProductSpecific }) {
    return (
        <tr>
            <td>
                {props.title}{props.tooltip !== undefined ? ' ' : ''}
                {props.tooltip !== undefined && (
                    <div className="tool-tip">
                        &#9432;
                        <span className="tool-tip-text">
                        {props.tooltip}
                    </span>
                    </div>
                )}
            </td>
            <td>
                <i className="ellipse ellipse-fiber"><span>Bredbånd via fibernet</span></i> {formatAmountWithCurrency(props.adjustment.fiber as number)}<br/>
                <i className="ellipse ellipse-mbb"><span>5G-internet</span></i> {formatAmountWithCurrency(props.adjustment.mbb as number)}<br/>
                <i className="ellipse ellipse-coax"><span>Bredbånd via kabel-tv-stik</span></i> {formatAmountWithCurrency(props.adjustment.coax as number)}
            </td>
        </tr>
    )
}
